import React from "react";
import "../../assets/styles/messages.css";

export default class Message extends React.Component {
  parseMessage(message) {
    let parsedMessage = [];
    let viewMessage = "";
    const reactStringReplace = require("react-string-replace");

    if (message) {
      if (
        message.messageParams &&
        message.messageParams.length > 0 &&
        typeof message.message === "string"
      ) {
        var className = window.provider === "bit" ? "link-white" : "link-blue";

        for (var i = 0; i < message.messageParams.length; i++) {
          switch (message.messageParams[i].messageParamType) {
            case 0: {
              //text
              //message.message  = message.message.replace('{' + i + '}', message.messageParams[i].displayName);
              var reg = "{(" + i + ")}";
              var re = new RegExp(reg);
              message.message = reactStringReplace(message.message, re, () => (
                <span key={i}>{message.messageParams[i].displayName}</span>
              ));
              break;
            }
            case 1: {
              //url
              var url = message.messageParams[i].paramValue;
              //  const text = message.message.replace('{'+i+'}',message.messageParams[i].paramValue)
              var reg = "{(" + i + ")}";
              var re = new RegExp(reg);

              message.message = reactStringReplace(message.message, re, () => (
                <a key={i} className={className} href={url}>
                  {message.messageParams[i].displayName}
                </a>
              ));
              break;
            }
            case 2: {
              //phone
              var url = "tel:" + message.messageParams[i].paramValue;
              // const text = message.message.replace('{'+i+'}',message.messageParams[i].paramValue)
              var reg = "{(" + i + ")}";
              var re = new RegExp(reg);
              message.message = reactStringReplace(message.message, re, () => (
                <a key={i} className={className} href={url}>
                  {message.messageParams[i].displayName}
                </a>
              ));
              break;
            }
          }
        }
        viewMessage = message.message;
        parsedMessage.push(viewMessage);
      } else if (typeof message !== "string" && message.message) {
        viewMessage = message.message;
        parsedMessage.push(viewMessage);
      } else if (typeof message == "string") {
        viewMessage = message;
        parsedMessage.push(viewMessage);
      } else if (message.statusCode != 1) {
        viewMessage = message.statusDescription;
        parsedMessage.push(viewMessage);
      }
    }

    //  var results = JSON.parse(message);
    // groupPid: null
    // result: null

    // statusTitle: null

    /*let parts = message.split(/\|/g);
        for (let i = 0; i < parts.length; i++) {
            if (parts[i] == "")
                continue;

            if (parts[i][0] == '@') {
                parts[i] = parts[i].substring(1);
                let urlParts = parts[i].split("__");
                urlParts[1] = urlParts[1] || urlParts[0];
                parsedMessage.push(<a key={i} tabIndex="0" href={urlParts[0]}>{urlParts[1]}</a>);
            }
            else if (parts[i][0] == '#') {
                let telPart = parts[i].substring(1);
                parsedMessage.push(<a key={i} tabIndex="0" href={"tel:" + telPart}>{telPart}</a>);
            }
            else {
                if (i !== 0) {
                    parsedMessage.push(<br key={"br" + i} />);
                }
                parsedMessage.push(<span key={i}>{parts[i]}</span>);
            }
        }
        */

    return parsedMessage;
  }

  render() {
    return (
      <span className="note-msg-text" role={this.props.role || ""}>
        {this.parseMessage(this.props.message)}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/Message.jsx